var $d706c914d748cb55$exports = {};
"use strict";
//Anropa funktion för att visa meny och uppdatera varukorgsikon när sidan har laddats klart.
document.addEventListener('DOMContentLoaded', ()=>{
    $d706c914d748cb55$var$getData();
    $d706c914d748cb55$var$updateCartIcon();
});
//Visa laddningsmeddelande
function $d706c914d748cb55$var$showLoadingMessage() {
    const menuEl = document.getElementById("menuContainer");
    menuEl.innerHTML = `<h3>Laddar menyn...</h3>`;
}
//Asynkron funktion som hämtar menydata från mitt API.
async function $d706c914d748cb55$var$getData() {
    $d706c914d748cb55$var$showLoadingMessage();
    try {
        const response = await fetch("https://dt207g-project-restapi.onrender.com/api/menu");
        if (!response.ok) throw new Error("N\xe4tverksfel");
        const data = await response.json();
        console.table(data);
        $d706c914d748cb55$var$renderData(data);
    } catch (error) {
        console.error("Fel vid h\xe4mtning:", error);
    } finally{
        console.log("F\xf6rfr\xe5gan avslutad.");
    }
}
//Skriv ut menydata på skärmen
function $d706c914d748cb55$var$renderData(data) {
    const menuEl = document.getElementById("menuContainer");
    menuEl.innerHTML = '';
    //Skapa kategoribehållare
    const categories = {
        Pizza: [],
        Pasta: [],
        Dryck: []
    };
    // Sortera menyobjekt in i kategorier
    data.forEach((item)=>{
        const cat = item.category?.toLowerCase();
        if (cat === "pizza") categories.Pizza.push(item);
        else if (cat === "pasta") categories.Pasta.push(item);
        else if (cat === "dryck") categories.Dryck.push(item);
    });
    //Rendera varje kategori
    for (const [category, items] of Object.entries(categories)){
        const section = document.createElement('section');
        section.classList.add('menuSection');
        const heading = document.createElement('h3');
        heading.textContent = category;
        heading.classList.add('menuTitle');
        section.appendChild(heading);
        items.forEach((menuItem)=>{
            const row = document.createElement('div');
            row.classList.add('menuItem');
            const veganIcon = menuItem.isVegan ? "Vegansk \uD83C\uDF31" : '';
            row.innerHTML = `
                <h4>${menuItem.name}</h4>
                <p class="description"><em>${menuItem.description}</em></p>
                <p><strong>Pris:</strong> ${menuItem.price} kr</p>
                <p class="vegan">${veganIcon}</p>
            `;
            //Anropar addToCart-funktion vid klick
            const button = document.createElement('button');
            button.textContent = "BEST\xc4LL";
            button.classList.add('addBtn');
            button.addEventListener('click', ()=>$d706c914d748cb55$var$addToCart(menuItem));
            row.appendChild(button);
            section.appendChild(row);
        });
        //Lägg till varje sektion
        menuEl.appendChild(section);
    }
}
//Funktion för att läsa cart från localStorage
function $d706c914d748cb55$var$getCart() {
    return JSON.parse(localStorage.getItem('cart')) || [];
}
//Funktion för att spara cart i localStorage
function $d706c914d748cb55$var$saveCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
}
//Lägg till i varukorg. Finns produkt så ökas antal med 1 och uppdaterar localStorage.
function $d706c914d748cb55$var$addToCart(menuItem) {
    const cart = $d706c914d748cb55$var$getCart();
    const existing = cart.find((item)=>item._id === menuItem._id);
    if (existing) existing.quantity++;
    else cart.push({
        ...menuItem,
        quantity: 1
    });
    $d706c914d748cb55$var$saveCart(cart);
    $d706c914d748cb55$var$updateCartIcon();
}
//Räknar total antal produkter
function $d706c914d748cb55$var$getCartCount() {
    const cart = $d706c914d748cb55$var$getCart();
    return cart.reduce((total, item)=>total + item.quantity, 0);
}
//Uppdaterar varukorgsikonen med rätt antal
function $d706c914d748cb55$var$updateCartIcon() {
    const cartEl = document.getElementById('cartContainer');
    const count = $d706c914d748cb55$var$getCartCount();
    cartEl.innerHTML = `
        <em class="fas fa-shopping-cart"></em>
        <span class="cart-count">${count}</span>
    `;
}
document.addEventListener('visibilitychange', ()=>{
    if (document.visibilityState === 'visible') $d706c914d748cb55$var$updateCartIcon();
});


//# sourceMappingURL=repo.881a1b6a.js.map
